<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>勢能-About</h2>
            <h2 style="padding-top: 10px;">聯絡我們</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Contact Area -->
<section class="contact-area ptb-100">
    <div class="container">
        <div class="section-title" style="max-width: 970px;">
            <span style="font-size: 4vh;">Contact Us</span>
            <!-- <h2>Drop us Message for any Query</h2> -->
            <p style="max-width: 100%;font-size: 18px;">碩達系統重視您的每一個想法，若您有任何疑問/建議/需要協助的地方，可於此處留下問題或上班時間聯絡客服人員，我們將竭誠為您服務，為了加速來信處理時間，請在主旨欄位選擇正確的分類選項。感謝您的配合！ </p>
            <p style="font-size: 18px;">聯絡資訊如下： </p>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-4 col-md-4">
                <div class="contact-image">
                    <img src="assets/img/contact/pic_06.jpg" alt="image">
                </div>
            </div>

            <div class="col-lg-8 col-md-8">
                <div class="contact-form">
                    <form id="contactForm">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input type="text" name="name" id="name" [(ngModel)]="name" class="form-control" required data-error="Please enter your name" placeholder="Name 姓名">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input type="email" name="email" id="email" [(ngModel)]="email" class="form-control" required data-error="Please enter your email" placeholder="Email 信箱">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input type="text" name="phone_number" id="phone_number" [(ngModel)]="phone_number" required data-error="Please enter your number" class="form-control" placeholder="Phone 電話">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="form-group">
                                    <input type="text" name="company_name" id="company_name" [(ngModel)]="company_name" required data-error="Please enter your company name" class="form-control" placeholder="Company name 公司名">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12" style="margin-bottom: 1rem;">
                                <div class="form-group">
                                    <select name="msg_subject" class="form-control" id="msg_subject" cols="30" rows="5" required data-error="Please enter your subject" placeholder="Subject 內容主旨">
                                        <option value=" " disabled selected>Subject 內容主旨</option>
                                        <option value="解決方案詢問">解決方案詢問</option>
                                        <option value="顧問服務需求">顧問服務需求</option>
                                        <option value="人力服務需求">人力服務需求</option>
                                        <option value="維護/續約相關">維護/續約相關</option>
                                        <option value="合作洽詢">合作洽詢</option>
                                        <option value="其他">其他</option>
                                    </select>
                                    <div class="help-block with-errors "></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12 ">
                                <div class="form-group ">
                                    <textarea name="message " class="form-control " id="message " [(ngModel)]="message " cols="30 " rows="5 " required data-error="Write your message " placeholder="Your Message "></textarea>
                                    <div class="help-block with-errors "></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12 ">
                                <button type="submit" class="btn btn-primary" (click)="sendemail()">Send Message</button>
                                <div id="msgSubmit" class="h3 text-center hidden "></div>
                                <div class="clearfix "></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="row ">
            <div class="col-lg-4 col-md-6 col-sm-6 ">
                <a href="mailto:sales@solarix.com.tw">
                    <div class="contact-info-box ">
                        <div class="icon ">
                            <!-- <i class='bx bx-envelope'></i> -->
                            <img src="assets/img/contact/icon_pic_1.png ">
                        </div>
                        <h3>Email 信箱</h3>
                        <p>sales@solarix.com.tw</p>
                        <p><br></p>
                    </div>
                </a>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 ">
                <a href="https://goo.gl/maps/upBxbrUy1S6DNL7f8" target="_blank">
                    <div class="contact-info-box ">
                        <div class="icon ">
                            <!-- <i class='bx bx-map'></i> -->
                            <img src="assets/img/contact/icon_pic_2.png ">
                        </div>

                        <h3>Location 地址</h3>
                        <p>10646 台北市大安區羅斯福路三段 37 號 7 樓</p>
                        <p><br></p>
                    </div>
                </a>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3 ">
                <div class="contact-info-box ">
                    <div class="icon ">
                        <!-- <i class='bx bx-phone-call'></i> -->
                        <img src="assets/img/contact/icon_pic_3.png ">
                    </div>

                    <h3>Call電話/傳真</h3>
                    <p><a href="tel:02-23625368">Tel: 02-23625368</a></p>
                    <p><a href="tel:02-23625560">Fax: 02-23625560</a></p>
                </div>
            </div>
        </div>
    </div>
</section>
<div style="width: 100%;height: 100%;position: fixed;background-color: #dedede;z-index: 999;top: 0;left: 0;opacity: 0.5;" *ngIf="loading"></div>
<!-- <div class="loading-overlay" *ngIf="loading" style="position: fixed;top: 40%;left: 50%;z-index: 9999;">
    <mat-progress-spinner mode="indeterminate" value="40" color="Primary"></mat-progress-spinner>
</div> -->
<div class="spinner-border load-spinner" role="status" *ngIf="loading">
    <span class="sr-only">Loading...</span>
</div>
<!-- End Contact Area -->